var o=function(o,r){return void 0===r.spacing[o]?o:r.spacing[o]},r=function(o,r){return void 0===r.colors[o]?o||"currentColor":r.colors[o]};export{r as themeColorOrString,o as themeSizeOrString};
//# sourceMappingURL=themeUtils.js.map
